module.exports = __webpack_public_path__ + "static/media/HalmonLui_Resume.28200e71.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/HalmonLui_Resume.pdf
// module id = 46
// module chunks = 0